import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { KeyUri } from "../key";

const TourBookingDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [booking, setBooking] = useState(null); const [loading, setLoading] = useState(true);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [submittingReview, setSubmittingReview] = useState(false);
  const [reviewSubmitted, setReviewSubmitted] = useState(false);
  const [existingReview, setExistingReview] = useState(null);
const [cancelModal, setCancelModal] = useState(false);
const [cancelLoading, setCancelLoading] = useState(false);
const [cancelResult, setCancelResult] = useState(null);

  useEffect(() => {
    fetchBooking();
  }, [id]);

const fetchBooking = async () => {
  try {
    const token = JSON.parse(localStorage.getItem("tokenUser"));

    const res = await axios.get(
      `${KeyUri.BACKEND_URI}/get-tour-booking/${id}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const bookingData = res.data.data;
    setBooking(bookingData);

  const reviewRes = await axios.get(
  `${KeyUri.BACKEND_URI}/tours/${bookingData.tourId._id}/reviews`,
  {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  }
);


const reviewsArray = reviewRes.data?.reviews || [];
const userReview = reviewsArray.find(
  (rev) =>
    rev.bookingId?.toString() === bookingData._id.toString()
);
if (userReview) {
  setExistingReview(userReview);
  setReviewSubmitted(true);
}
  } catch (error) {
    console.error("Error fetching booking:", error);
  } finally {
    setLoading(false);
  }
};

const handleCancel = async () => {
  setCancelModal(true);  
};

const confirmCancel = async () => {
  try {
    setCancelLoading(true);
    const token = JSON.parse(localStorage.getItem("tokenUser"));

    const response = await axios.patch(
      `${KeyUri.BACKEND_URI}/tour-booking/cancel/${id}`,
      {},
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    
    setCancelResult(response.data);
    setCancelModal(false);
    fetchBooking(); 
    
  } catch (error) {
    console.error("Cancel failed:", error.response?.data || error);
    alert(error.response?.data?.message || "Cancellation failed");
  } finally {
    setCancelLoading(false);
  }
};

const handleSubmitReview = async () => {
  try {
    if (rating === 0) {
      alert("Please select a rating");
      return;
    }

    setSubmittingReview(true);

    const token = JSON.parse(localStorage.getItem("tokenUser"));

 await axios.post(
  `${KeyUri.BACKEND_URI}/tours/${booking.tourId._id}/reviews`,
  {
    bookingId: booking._id,
    rating,
    comment,
  },
  {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  }
);

    setReviewSubmitted(true);
    alert("Review submitted successfully!");
  } catch (error) {
    console.error("Review submission failed:", error);
    alert("Failed to submit review");
  } finally {
    setSubmittingReview(false);
  }
};

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (!booking) return <div className="text-center mt-10">Booking not found</div>;

  const tour = booking?.tourId;


const today = new Date();
const travelDate = new Date(booking.date);

const canCancel = 
  booking.status === "confirmed" && 
  today < travelDate &&  
  booking.userId?._id?.toString() === 
    JSON.parse(localStorage.getItem("tokenUser") || "{}")?.id;


let tripEndDate = new Date(travelDate);

const durationString = tour?.duration?.toLowerCase() || "";

// Extract days
const dayMatch = durationString.match(/(\d+)\s*day/);
const days = dayMatch ? parseInt(dayMatch[1]) : 0;

// Extract hours
const hourMatch = durationString.match(/(\d+)\s*hour|(\d+)\s*hr/);
const hours = hourMatch
  ? parseInt(hourMatch[1] || hourMatch[2])
  : 0;

// Add days
tripEndDate.setDate(tripEndDate.getDate() + days);

// Add hours
tripEndDate.setHours(tripEndDate.getHours() + hours);

// Allow review only after trip ends
const canReview =
  booking.status === "confirmed" &&
  today >= tripEndDate &&
  !existingReview;

  const statusClasses =
    booking.status === "confirmed"
      ? "bg-green-500"
      : booking.status === "cancelled"
      ? "bg-red-500"
      : booking.status === "failed"
      ? "bg-gray-500"
      : "bg-yellow-500";

  return (
    <div className="max-w-5xl mx-auto p-6 mt-32 mb-10">

  <div className="p-4 max-w-xl mr-80">
         <button
        onClick={() => navigate(-1)}
        className="text-gray-600 hover:text-gray-800 hidden md:block mr-100"
      >
        ← Go Back
      </button>
      </div> 

      {/* Header */}
      <div className="bg-white shadow rounded-lg p-6 mb-6 flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold">
            Booking Reference: {booking.bookingReference}
          </h2>
          <p className="text-sm text-gray-500">
            Booked on {new Date(booking.createdAt).toDateString()}
          </p>
        </div>

        <span className={`px-3 py-1 rounded-full text-white ${statusClasses}`}>
          {booking.status}
        </span>
      </div>

      {/* Tour Info */}
      <div className="bg-white shadow rounded-lg p-6 mb-6 flex gap-6">
        <img
          src={tour?.image_url?.[0]}
          alt={tour?.title}
          className="w-40 h-32 object-cover rounded"
        />
        <div>
          <h3 className="text-xl font-semibold">{tour?.title}</h3>
          <p>{tour?.location}</p>
          <p>{tour?.duration}</p>
        </div>
      </div>

      {/* Booking Details */}
      <div className="bg-white shadow rounded-lg p-6 mb-6">
        <h3 className="text-lg font-semibold mb-4">Booking Details</h3>
        <p><strong>Travel Date:</strong> {new Date(booking.date).toDateString()}</p>
        <p><strong>Guests:</strong> {booking.guests}</p>
        <p><strong>Booked On:</strong> {new Date(booking.createdAt).toDateString()}</p>
      </div>

      {/* Guest Info */}
      <div className="bg-white shadow rounded-lg p-6 mb-6">
        <h3 className="text-lg font-semibold mb-4">Guest Information</h3>
        <p><strong>Name:</strong> {booking.firstName} {booking.lastName}</p>
        <p><strong>Email:</strong> {booking.email}</p>
        <p><strong>Phone:</strong> {booking.phone}</p>
      </div>

      {/* Payment */}
      <div className="bg-white shadow rounded-lg p-6 mb-6">
        <h3 className="text-lg font-semibold mb-4">Payment Summary</h3>
        <p><strong>Amount Paid:</strong> ₹{booking.amountPaid}</p>
        <p><strong>Currency:</strong> {booking.currency}</p>
        <p><strong>Payment ID:</strong> {booking.razorpayPaymentId || "N/A"}</p>
        <p><strong>Status:</strong> {booking.status}</p>
      </div>

      {/* Special Requests */}
      {booking.specialRequests && (
        <div className="bg-white shadow rounded-lg p-6 mb-6">
          <h3 className="text-lg font-semibold mb-4">Special Requests</h3>
          <p>{booking.specialRequests}</p>
        </div>
      )}

{/* ⭐ Review Section */}
{canReview && (
  <div className="bg-white shadow rounded-lg p-6 mb-6">
    <h3 className="text-lg font-semibold mb-4">
      Leave a Review
    </h3>

    {/* Star Rating */}
    <div className="flex space-x-2 mb-4">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          onClick={() => setRating(star)}
          className={`text-3xl transition ${
            star <= rating ? "text-yellow-400" : "text-gray-300"
          }`}
        >
          ★
        </button>
      ))}
    </div>

    {/* Comment */}
    <textarea
      rows="4"
      value={comment}
      onChange={(e) => setComment(e.target.value)}
      placeholder="Share your travel experience..."
      className="w-full border rounded-lg p-3 mb-4 focus:outline-none focus:ring-2 focus:ring-yellow-400"
    />

    <button
      onClick={handleSubmitReview}
      disabled={submittingReview}
      className="bg-black text-white px-6 py-2 rounded-lg hover:opacity-90 disabled:opacity-50"
    >
      {submittingReview ? "Submitting..." : "Submit Review"}
    </button>
  </div>
)}

{reviewSubmitted && (
  <div className="bg-green-50 border border-green-200 text-green-700 p-4 rounded-lg mb-6">
    Thank you! Your review has been submitted.
  </div>
)}

{existingReview && (
  <div className="bg-white shadow rounded-lg p-6 mb-6">
    <h3 className="text-lg font-semibold mb-4">Your Review</h3>

    <div className="text-yellow-400 text-2xl mb-2">
      {"★".repeat(existingReview.rating)}
      {"☆".repeat(5 - existingReview.rating)}
    </div>

    <p className="text-gray-700">{existingReview.comment}</p>
  </div>
)}
      {/* Cancel Button */}
{/* 🚨 CANCEL CONFIRMATION MODAL */}
{canCancel && (
  <>
    {/* Cancel Button */}
    <div className="text-right mb-6">
      <button
        onClick={handleCancel}
        className="bg-red-500 hover:bg-red-600 text-white px-8 py-3 rounded-lg font-semibold shadow-lg hover:shadow-xl transition-all"
      >
        Cancel Booking
      </button>
    </div>

    {/* Confirmation Modal */}
    {cancelModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl p-8 max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="text-center mb-6">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">Cancel Booking?</h3>
            <p className="text-gray-600">
              This action cannot be undone. Are you sure?
            </p>
          </div>

          <div className="space-y-4">
            <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg">
              <p className="text-sm text-yellow-800 font-medium">
                <strong>Refund Policy:</strong>
              </p>
              <p className="text-xs text-yellow-700 mt-1">
                {(() => {
                  const travelDate = new Date(booking.date);
                  const today = new Date();
                  const daysDiff = (travelDate - today) / (1000 * 60 * 60 * 24);
                  return daysDiff >= 7 
                    ? " 50% refund (₹" + Math.round(booking.amountPaid * 0.5) + ")"
                    : " No refund within 7 days";
                })()}
              </p>
            </div>

            <div className="flex gap-3 pt-4">
              <button
                onClick={() => setCancelModal(false)}
                className="flex-1 bg-gray-200 text-gray-800 px-6 py-3 rounded-xl font-semibold hover:bg-gray-300 transition-all"
                disabled={cancelLoading}
              >
                Cancel
              </button>
              <button
                onClick={confirmCancel}
                disabled={cancelLoading}
                className="flex-1 bg-red-500 text-white px-6 py-3 rounded-xl font-semibold hover:bg-red-600 disabled:opacity-50 transition-all"
              >
                {cancelLoading ? "Cancelling..." : "Yes, Cancel"}
              </button>
            </div>
          </div>
        </div>
      </div>
    )}
  </>
)}

{/* ✅ SUCCESS MODAL - Shows refund details */}
{cancelResult && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center">
      <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <svg className="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      
      <h3 className="text-2xl font-bold text-gray-900 mb-4">Booking Cancelled!</h3>
      <p className="text-gray-600 mb-6">
        Reference: <strong>{cancelResult.bookingRef}</strong>
      </p>
      
      {cancelResult.refundAmount > 0 ? (
        <div className="bg-green-50 border border-green-200 p-6 rounded-xl mb-6">
          <p className="text-lg font-semibold text-green-800 mb-2">
            Refund Processing
          </p>
          <p className="text-green-700">
            ₹{cancelResult.refundAmount} will be refunded to your original payment method
          </p>
          {cancelResult.refundId && (
            <p className="text-sm text-green-600 mt-2">
              Refund ID: {cancelResult.refundId}
            </p>
          )}
        </div>
      ) : (
        <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg mb-6">
          <p className="text-yellow-800">
             No refund as cancellation was within 7 days
          </p>
        </div>
      )}
      
      <div className="flex gap-3">
        <button
          onClick={() => {
            setCancelResult(null);
            setCancelModal(false);
          }}
          className="flex-1 bg-gray-500 text-white px-6 py-3 rounded-xl font-semibold hover:bg-gray-600"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}



{/* Cancellation Policy Notice */}
{booking.status !== "cancelled" && (
  <div className="mt-6 p-4 bg-yellow-50 rounded-lg">
    <p className="text-sm text-yellow-700">
      ⓘ Cancellation is available before travel date.
      {booking.date && (
        <>
          <br />
          After <strong>{new Date(booking.date).toLocaleDateString('en-IN')}</strong>,
          cancellations will no longer be permitted.
        </>
      )}
    </p>
  </div>
)}


    </div>
  );
};

export default TourBookingDetail;